/* [DV-REVIEW-TAKSIT 2026-07-29 r2] Ozel olcu "Son kez kontrol edin" modali fiyat blogu zenginlestirme.
 * ADDITIVE — hicbir mevcut dosyayi degistirmez. Canli DOM'dan okur, iki sey ekler:
 *   1) Ustu cizili indirimsiz fiyat (#ozel-olcu-compare-price)
 *   2) "6 taksit, pesin fiyatina" seridi (son fiyat / 6)
 * r2 DUZELTME: r1'deki MutationObserver GERI-BESLEME DONGUSU giderildi (modal acilinca
 *   renderer donuyordu). Artik observer SADECE rev'in open/class ATTRIBUTE'unu izler
 *   (subtree/childList YOK), yazimlar kosullu (deger degismediyse DOM'a dokunmaz), ve
 *   re-entrancy guard var. Bizim yazimlarimiz observer'i asla tetiklemez.
 * Footer grid'ine (total/notice/confirm) DOKUNMAZ. Deger yoksa hicbir sey yapmaz (fail-silent).
 * Idempotent. Sepete ekleme akisina DOKUNMAZ.
 */
(function () {
  'use strict';
  var STYLE_ID = 'dvrt-style';
  var REVIEW_ID = 'bp-dv-order-review';
  var mo = null;
  var enhancing = false;
  var scheduled = false;

  function parseTL(txt) {
    if (!txt) return NaN;
    var s = String(txt).replace(/[^\d.,]/g, '').replace(/\./g, '').replace(',', '.');
    var n = parseFloat(s);
    return isFinite(n) ? n : NaN;
  }
  function fmtTL(n) {
    try { return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n); }
    catch (e) { return String(Math.round(n * 100) / 100); }
  }
  function setText(el, val) { if (el && el.textContent !== val) el.textContent = val; }

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent =
      /* fiyat blogu flex-row-nowrap -> wrap yap ki tam-genislik eklemeler kendi satirina dussun */
      '.dvp-review-total{flex-wrap:wrap}' +
      '.dvrt-was{flex-basis:100%;width:100%;display:flex;align-items:baseline;gap:8px;' +
        'margin:0 0 8px;font-size:13px;color:#b7ada0}' +
      '.dvrt-was .dvrt-lbl{color:#a89e91}' +
      '.dvrt-was s{color:#9c9488;font-size:15px;text-decoration:line-through;text-decoration-color:#7d7568}' +
      '.dvrt-was .dvrt-save{margin-left:auto;color:#d0b587;font-weight:700;font-size:12px;white-space:nowrap}' +
      '.dvrt-taksit{flex-basis:100%;width:100%;box-sizing:border-box;display:flex;align-items:center;gap:9px;' +
        'margin:12px 0 0;padding:11px 13px;border-radius:14px;' +
        'background:linear-gradient(180deg,rgba(214,177,115,.16),rgba(214,177,115,.05));' +
        'border:1px solid rgba(214,177,115,.36)}' +
      '.dvrt-taksit .dvrt-ic{font-size:16px;line-height:1}' +
      '.dvrt-taksit .dvrt-tx{flex:1;font-size:12.5px;line-height:1.35;color:#e9e0d2}' +
      '.dvrt-taksit .dvrt-tx b{color:#d6b173;font-weight:800}' +
      '.dvrt-taksit .dvrt-amt{font-family:Georgia,serif;font-size:16px;font-weight:700;color:#fff;white-space:nowrap}';
    (document.head || document.documentElement).appendChild(st);
  }

  function enhance() {
    if (enhancing) return;              // re-entrancy guard
    var rev = document.getElementById(REVIEW_ID);
    if (!rev || !(rev.open || rev.hasAttribute('open'))) return;

    var box = rev.querySelector('.dvp-review-total') || rev.querySelector('.bp-dv-review__total:not([hidden])');
    var finalEl = rev.querySelector('#dvp-review-final') || rev.querySelector('#bp-dv-review-price');
    if (!box || !finalEl) return;

    var finalVal = parseTL(finalEl.textContent);
    if (!isFinite(finalVal) || finalVal <= 0) return;

    enhancing = true;
    try {
      // 1) Ustu cizili — box'un ILK cocugu (tam-genislik ust satir)
      var cmpEl = document.getElementById('ozel-olcu-compare-price');
      var cmpTxt = cmpEl ? (cmpEl.textContent || '').trim() : '';
      var cmpVal = parseTL(cmpTxt);
      var hasCompare = isFinite(cmpVal) && cmpVal > finalVal + 0.5;

      var was = box.querySelector('.dvrt-was');
      if (hasCompare) {
        if (!was) {
          was = document.createElement('div');
          was.className = 'dvrt-was';
          was.innerHTML = '<span class="dvrt-lbl">İndirimsiz</span><s></s><span class="dvrt-save"></span>';
        }
        if (box.firstElementChild !== was) box.insertBefore(was, box.firstChild);
        setText(was.querySelector('s'), cmpTxt);
        setText(was.querySelector('.dvrt-save'), '₺' + fmtTL(cmpVal - finalVal) + ' tasarruf');
      } else if (was) {
        was.remove();
      }

      // 2) Taksit seridi — box'un SON cocugu (tam-genislik alt satir)
      var taksit = box.querySelector('.dvrt-taksit');
      if (!taksit) {
        taksit = document.createElement('div');
        taksit.className = 'dvrt-taksit';
        taksit.innerHTML =
          '<span class="dvrt-ic">💳</span>' +
          '<span class="dvrt-tx">6 taksit, <b>peşin fiyatına</b> — vade farksız</span>' +
          '<span class="dvrt-amt"></span>';
      }
      if (box.lastElementChild !== taksit) box.appendChild(taksit);
      setText(taksit.querySelector('.dvrt-amt'), '6 × ₺' + fmtTL(finalVal / 6));
    } catch (e) {
      /* fail-silent */
    } finally {
      enhancing = false;
    }
  }

  function scheduleBurst() {
    // modal acildiginda fiyat asenkron doluyor; birkac gecikmeli deneme (her biri kosullu -> zararsiz)
    [0, 250, 700, 1600].forEach(function (d) {
      setTimeout(function () { try { enhance(); } catch (e) {} }, d);
    });
  }
  function scheduleOnce() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; try { enhance(); } catch (e) {} }, 60);
  }

  function boot() {
    injectStyle();
    var rev = document.getElementById(REVIEW_ID);
    if (rev) {
      // SADECE open/class attribute — subtree/childList YOK => kendi yazimlarimiz observer'i tetikleyemez
      mo = new MutationObserver(function () { scheduleOnce(); });
      mo.observe(rev, { attributes: true, attributeFilter: ['open', 'class'] });
    }
    // Dock butonuna tiklaninca modal acilir; fiyat render'ini yakalamak icin gecikmeli deneme
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('#dv-purchase-dock-button')) {
        scheduleBurst();
      }
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.__dvrtEnhance = enhance;
})();
